<template>
  <div class="popup-new" id="classes_for_analysis_popup">
    <div class="popup-inner">
      <!--CLOSE EVENT -->
      <a  class="popup-close" data-toggle="modal" data-target="#classes_for_analysis_popup" href="#"><img src="../../assets/cross.png"></a>
      <div class="wrap-popup" style="overflow: hidden; height: 100%;">
        <!--SLIDE PAGE INSIDE Tanach Favorites Recent -->
        <select-text-popup id="mypopup"
                           type="class"
                           class="text-selection-popup"
                           style="display: none" @cancel="showPopup('close')"
                           :text="currentText"
                           @select="setClass($event); showPopup('close')"></select-text-popup>
        <!--Select classes for Analysis INNER CONTENT-->
        <div id="inner-below">
          <div class="txt-box">
            <div class="img-txt">
              <img src="../../assets/Lowercase-Outline-white.png">
              <h2 class="white"><strong>Classes:</strong> Define text classes for analysis</h2>
              <div class="i-doc white float-right"><i class="fas fa-info-circle fa-lg" @click="openHelpTab"></i></div>
            </div>
          </div>
          <div class="classes-area">
            <div class="baron mybaron">
              <div id="scrollable12" class="baron__scroller">
                <h3>Define two or more classes of biblical texts for analysis</h3>
                <manage-text-control v-for="(text, index) in allClasses"
                    :key="text.id"
                    :text="text"
                    :placeholder-name="'Class ' + (index+1)"
                    @show-select-text="showSelectText"
                    :showTooFewClassesError = "showTooFewClassesError"
                    :context="'Class'"
                >
                  <div v-if="allClasses.length > 2" class="tooltip-holder cross">
                      <a class="removeclass" @click="removeClicked(index)" href="#"><img class="tooltip-holder-img" src="../../assets/ic_cancel2.png"></a>
                      <div :id="'tooltip-removeclass' + index" class="tooltip">
                        <p>Are you sure that you want to remove this class?</p>
                        <div class="button-holder">
                          <a class="bt sm active bg-white blue" @click="hideTooltip('tooltip-removeclass' + index); removeClassSelection(index)" href="#">Yes</a>
                          <a class="bt sm bg-blue" @click="hideTooltip('tooltip-removeclass' + index)">No</a>
                        </div>
                      </div>
                    </div>
                </manage-text-control>
                <a class="addclass blue" href="#" @click="addAdditionalClass()">Add class</a>
                <div class="empty-class"></div>
              </div>
              <div class="baron__track">
                <div class="baron__bar"></div>
              </div>
            </div>
          </div>
          <div class="tab-footer">
            <div class="tooltip-holder pull-right">
              <button  type="button" class="button lg bg-blue pull-right hoverable analyze" @click="analyzeClicked()"><div class="anim"></div>Analyze Classes</button>
              <div v-if="showTooFewClassesError" class="analyze-errors-tooltip tooltip error-tooltip" >
                <a class="canceltooltip" href="#" @click="showTooFewClassesError = false"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
                <p>You must select <br>at least two classes</p>
              </div>
              <div v-if="showTooFewChaptersError" class="tooltip tooltip-too-few-chapters" >
                <a class="canceltooltip" href="#" @click="showTooFewChaptersError = false"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
                <p>Each class must <br>have at least two chapters. Please correct this{{ tooFewChaptersErrorText }}.</p>
              </div>
              <div v-if="false" class="tooltip tooltip-too-few-verses">
                <p>You have provided less than 200 verses of training text{{ tooFewVersesErrorText }}.<br >The program's capacity to classify new texts might therefore be compromised.</p>
                <div class="button-holder">
                  <a class="bt sm active bg-white blue" @click="showTooFewVersesError = false" href="#">Cancel</a>
                  <a class="bt sm bg-blue" @click="analyzeClicked(OVERRIDE_TOO_FEW_VERSES)">Override</a>
                </div>
              </div>
              <div v-if="showOverlapError" class="analyze-errors-tooltip tooltip error-tooltip" >
                <a class="canceltooltip" href="#" @click="showOverlapError = false"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
                <p>Some text appears <br>in more than one class</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import 'jquery-ui-bundle'
import 'jquery-ui-bundle/jquery-ui.css'
import SelectTextPopup from './selectTextPopup'
import textMixins from '../../mixins/textMixins'
import routeGlobals from '../../mixins/routeGlobals'
import ManageTextControl from './manageTextControl'
import {StateChanges} from '../../store/stateChanges'
import {Text} from '../../texts'
// import {versesInKey} from '../../mixins/book_to_chapter_and_verse_counts'

function gtag () { window.dataLayer.push(arguments) }

export default {
  name: 'classAnalysisPopup',
  components: {SelectTextPopup, ManageTextControl},
  data () {
    return {
      currentText: null,
      showTooFewClassesError: false,
      OVERRIDE_TOO_FEW_VERSES: true, // a constant, but needs to be accessible in HTML
      showTooFewVersesError: false,
      tooFewVersesErrorText: '',
      showTooFewChaptersError: false,
      tooFewChaptersErrorText: '',
      showOverlapError: false
    }
  },
  mixins: [textMixins, routeGlobals],
  methods: {
    openHelpTab () { // directories defined in routeGlobals
      window.open(this.helpRootDir + this.helpPagesSubDir + 'define-text-classes.htm')
    },
    showPopup: function (action, text) {
      if (text !== undefined) {
        this.currentText = text
      }
      // Set the effect type
      var effect = 'slide'
      if (action === 'open') {
        // Set the duration
        var duration = 500
        $('#mypopup').show(effect, {direction: 'right', queue: false}, duration).fadeIn({queue: false})
        $('#mypopup').css({opacity: 0}).animate({opacity: 1}, 800)
      } else {
        // Set the duration
        duration = 300
        $('#mypopup').hide(effect, {direction: 'right', queue: false}, duration).fadeIn({queue: false})
      }
    },
    addAdditionalClass: function () {
      this.$store.commit(StateChanges.ADD_CLASS, new Text())
    },
    removeClassSelection: function (index) {
      this.removeClass(index)
    },
    hideTooltip (tooltipId) {
      document.getElementById(tooltipId).style.setProperty('display', 'none')
    },
    removeClicked (index) {
      const tip = document.getElementById('tooltip-removeclass' + index)
      tip.style.setProperty('display', 'block')
      const bounds = document.getElementById('scrollable12').parentElement
      const innerTop = tip.getBoundingClientRect().top
      const outerTop = bounds.getBoundingClientRect().top
      const delta = outerTop - innerTop
      if (delta > 0) {
        let outerTop = $('#scrollable12').parent().scrollTop()
        $('#scrollable12').parent().animate({scrollTop: outerTop - delta}, 250)
      }
    },
    analyzeClicked (overRideTooFewVerses = false) {
      if (this.classes.length < 2) {
        this.showTooFewClassesError = true
        return
      }
      this.showTooFewClassesError = false
      // test for short classes
      // first test for too few chapters (which is critical)
      // chapter counts don't have to be accurate, they just need to detect if there's more than ONE
      const chapterCounts = this.classes.map(classData => {
        // console.log('classData.keys:')
        // console.log(classData.keys)
        if (classData.keys.some(k => !(k.includes('Chapter')) && !(k.includes('Obadiah')))) return 2
        if (classData.keys.length < 2) return classData.keys.length
        let firstKeyWithoutPasuk = classData.keys[0].replace(/\/Pasuk \d*$/, '') + '/'
        return classData.keys.slice(1).filter(k => !(k.includes(firstKeyWithoutPasuk))).length + 1
      })
      console.log('chapterCounts:')
      console.log(chapterCounts)
      if (chapterCounts.some(count => count < 2)) {
        this.showTooFewChaptersError = true
        let tooSmallClasses = this.classes.filter((classData, index) => { return chapterCounts[index] < 2 })
        console.log('tooSmallClasses:')
        console.log(tooSmallClasses)
        this.tooFewChaptersErrorText = ' in ' + tooSmallClasses.map(classData => {
          return classData.name ? classData.name : 'Class ' + (this.classes.map(classData => classData.id).indexOf(classData.id) + 1)
        }).join(', ')
        if (tooSmallClasses.length > 1) this.tooFewChaptersErrorText = this.tooFewChaptersErrorText.replace(/,([^,]*)$/, ' and $1')
        return
      }
      this.showTooFewChaptersError = false
      // next test for too few verses (currently not actually applied HERE, but rather in result.vue)
      /*
      // verse counts don't have to be accurate, they just need to detect if the text is too short
      // DL - but for now, they are accurate
      const verseCounts = this.classes.map(classData => {
        let verseCount = 0
        for (const key of classData.keys) {
          if (/Pasuk \d*$/.test(key)) {
            verseCount += 1
          } else {
            verseCount += versesInKey(key)
          }
        }
        return verseCount
      })
      console.log('verseCounts:')
      console.log(verseCounts)
      if ((verseCounts.some(count => count < 200)) && !overRideTooFewVerses) {
        this.showTooFewVersesError = true
        let tooSmallClasses = this.classes.filter((classData, index) => { return verseCounts[index] < 200 })
        console.log('tooSmallClasses:')
        console.log(tooSmallClasses)
        this.tooFewVersesErrorText = ' in ' + tooSmallClasses.map(classData => {
          return classData.name ? classData.name : 'Class ' + (this.classes.map(classData => classData.id).indexOf(classData.id) + 1)
        }).join(', ')
        if (tooSmallClasses.length > 1) this.tooFewVersesErrorText = this.tooFewVersesErrorText.replace(/,([^,]*)$/, ' and $1')
        return
      }
      */
      this.showTooFewVersesError = false
      // test for overlapping classes
      for (const classData of this.classes) {
        for (const otherClassData of this.classes) {
          if (classData === otherClassData) continue
          if (classData.keys.some(key => otherClassData.keys.some(otherKey => (otherKey + '/').startsWith(key + '/')))) {
            this.showOverlapError = true
            return
          }
        }
      }
      this.showOverlapError = false
      // document.getElementsByClassName('error-tooltip')[0].classList.toggle()
      $('#classes_for_analysis_popup').modal('hide')
      gtag('config', 'UA-103843509-5', {'page_path': 'analyze-classes'})
      this.analyze()
    },
    showSelectText (text) {
      this.showTooFewClassesError = false
      this.showTooFewChaptersError = false
      this.showTooFewVersesError = false
      this.showPopup('open', text)
    }
  },
  mounted () {
    this.initExperimentClasses()
    $('#classes_for_analysis_popup').on('hidden.bs.modal', function () {
      $('#mypopup').hide()
    })
  },
  beforeDestroy () {
    $('#classes_for_analysis_popup').modal('hide')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
  .analyze-errors-tooltip {
    display: initial;
  }
  .tooltip-too-few-verses, .tooltip-too-few-chapters {
    display: block;
    bottom: 60px;
  }
  .tooltip-too-few-chapters {
    padding-bottom: 5px;
  }
  .tooltip-too-few-verses p, .tooltip-too-few-chapters p {
    margin-bottom: 10px;
  }
  .tooltip-too-few-verses:after, .tooltip-too-few-verses:before,
  .tooltip-too-few-chapters:after, .tooltip-too-few-chapters:before {
    left: 115px;
  }

</style>



// WEBPACK FOOTER //
// src/components/experiment/classAnalysisPopup.vue